const { CONSTANTS } = require('../../config')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} brand
 * @param {string} country
 */
function zopimInit ({ brand, country } = {}) {
  if (!brand || !country || typeof window === 'undefined') return

  const constants = CONSTANTS[country?.toUpperCase()]
  if (!constants) return

  const id = brand === 'broker'
    ? constants.ZOPIM.BROKER
    : constants.ZOPIM.ZMARTA

  if (!id) return

  /* istanbul ignore next */
  window.$zopim || (function (d, s) {
    const z = window.$zopim = function (c) {
      z.push(c)
    }
    const $ = z.s =
      d.createElement(s)
    const e = d.getElementsByTagName(s)[0]
    z.set = function (o) {
      z.set.push(o)
    }
    z._ = []
    z.set._ = []
    $.async = !0
    $.setAttribute('charset', 'utf-8')
    $.src = `https://v2.zopim.com/?${id}`
    z.t = +new Date()
    $.type = 'text/javascript'
    e && e.parentNode.insertBefore($, e)
  })(document, 'script')
}

module.exports = { zopimInit }
